var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAverage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.25,11.5H4.5V1.75C4.5,1.34,4.17,1,3.75,1l0,0C3.34,1,3,1.34,3,1.75v9.75H1.75C1.33,11.5,1,11.84,1,12.25 S1.33,13,1.75,13H3v1.3c0,0.41,0.34,0.75,0.75,0.75S4.5,14.72,4.5,14.3V13h9.75c0.41,0,0.75-0.34,0.75-0.75S14.67,11.5,14.25,11.5z  M6.05,9.31c0.41,0,0.75,0.34,0.75,0.75s-0.34,0.75-0.75,0.75S5.3,10.47,5.3,10.06S5.64,9.31,6.05,9.31z M6.55,6.81 c0.41,0,0.75,0.34,0.75,0.75S6.96,8.31,6.55,8.31S5.8,7.97,5.8,7.56S6.14,6.81,6.55,6.81z M8.55,8.81c0.41,0,0.75,0.34,0.75,0.75 s-0.34,0.75-0.75,0.75S7.8,9.97,7.8,9.56S8.14,8.81,8.55,8.81z M9.05,6.31c0.41,0,0.75,0.34,0.75,0.75S9.46,7.81,9.05,7.81 S8.3,7.47,8.3,7.06S8.64,6.31,9.05,6.31z M9.55,3.81c0.41,0,0.75,0.34,0.75,0.75S9.96,5.31,9.55,5.31S8.8,4.97,8.8,4.56 S9.14,3.81,9.55,3.81z M11.55,5.81c0.41,0,0.75,0.34,0.75,0.75s-0.34,0.75-0.75,0.75S10.8,6.97,10.8,6.56S11.14,5.81,11.55,5.81z  M12.05,3.31c0.41,0,0.75,0.34,0.75,0.75s-0.34,0.75-0.75,0.75S11.3,4.47,11.3,4.06S11.64,3.31,12.05,3.31z M14.05,1.81 c0.41,0,0.75,0.34,0.75,0.75s-0.34,0.75-0.75,0.75S13.3,2.97,13.3,2.56S13.64,1.81,14.05,1.81z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAverage);
export default __webpack_public_path__ + "static/media/icon_average.daf703d69248e8343851af854997ba37.svg";
export { ForwardRef as ReactComponent };